// extracted by mini-css-extract-plugin
export default {"link":"F7W6umO_grmBINWIl79m","active":"_QG5d1M8xUG5AFcLFGop","disabled":"mJFb29PTmCezTYTFNvbM","placeHolderShimmer":"SnXVc4ogsDxBtXSdYZ2Z"};